import React, { Component } from 'react';
import v from 'vudu';
import { format as f } from 'stylesheet';
import now from 'utils/now';
import importAll from 'utils/importAllFromFolder';
import aspectRatio from 'utils/aspectRatio';
import loadImage from 'image-promise';

const images = importAll(require.context('assets/border-star', false, /\.(png)$/));

const localClasses = v({
  borderStar: aspectRatio(1, 1)({
    backgroundImage: `url(${images[0]})`,
    backgroundSize: 'contain',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat'
  }),
  borderStarInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
});

export default class BorderStar extends Component {

  componentDidMount() {
    // Disabled because of a flicker
    return;
    loadImage(images).then(() => {
      let fps          = 30,
          currentFrame = 0,
          totalFrames  = images.length,
          ref          = this.ref,
          currentTime  = now();
      (function animloop(time){
        let delta = (time - currentTime) / 1000;
        currentFrame += (delta * fps);
        let frameNum = Math.floor(currentFrame);
        if (frameNum >= totalFrames) currentFrame = frameNum = 0;
        requestAnimationFrame(animloop);
        ref.style.backgroundImage = `url(${images[frameNum]})`;
        currentTime = time;
      })(currentTime);
    });

  }

  render() {
    return (
      <div className={localClasses.borderStar} ref={r => this.ref = r} style={this.props.style}>
        <div className={f('content', localClasses.borderStarInner)}>
          {this.props.children}
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/BorderStar.js